<template>
  <div v-if="loading === false">
    <router-view/>
    <vue-progress-bar></vue-progress-bar>
  </div>
</template>

<script>
import { setCsrfToken } from './services/auth.service';

export default {
    name: 'App',
    data() {
        return {
            loading: false,
        };
    },
    async created() {
        this.loading = true;
        await setCsrfToken();
        this.loading = false;

      this.$watch(
              () => this.$route.params,
              () => {
                if (this.$route.query.switchsite) {
                  this.$store.state.auth.user.activateSite(this.$route.query.switchsite);
                  this.$root.$emit('activateSite', this.$route.query.switchsite);
                }
              },
      );
    },
};
</script>
